import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { LocalizationService } from "../localization.service";

@Injectable()
export class LocalizationInterceptor implements HttpInterceptor {

    private static readonly ACCEPT_LANGUAGE_HEADER = 'Accept-Language';

    constructor(private readonly localizationService: LocalizationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedRequest = req.clone({
            setHeaders: {
                [LocalizationInterceptor.ACCEPT_LANGUAGE_HEADER]: this.localizationService.getAcceptLanguage()
            }
        });
        return next.handle(clonedRequest);
    }
}
